import React from 'react';
import ProjectDetailsModal from './ProjectDetailsModal';

const Projects = ({ sectionName, projects }) => {
    const [modalShow, setModalShow] = React.useState(false);
    const [projectData, setProjectData] = React.useState(projects[0]);

    const detailsModalOnShow = (data) => {
        setModalShow(true);
        setProjectData(data);
    };

    const detailsModalOnClose = () => setModalShow(false);

    const ProjectCardList = projects.map((project) => {
        return (
            <div
                className="card"
                key={project.title}
                style={{ cursor: 'pointer', marginBottom: '80px' }}
                onClick={() => detailsModalOnShow(project)}
            >
                <div className="row g-0">
                    <div className="col-md-4">
                        <img
                            src={project.images[0]}
                            // height="200"
                            alt="projectImages"
                            className="rounded-start img-thumbnail mx-auto my-auto"
                        />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body">
                            <h2 className="card-title text-center">{project.title}</h2>
                            <p className="card-text text-center">
                                <h4 className="text-muted">{project.startDate}</h4>
                            </p>
                            <p className="modal-description">{project.description}</p>
                            <p className="card-text text-center">
                                <h4 className="text-muted">Click for more information</h4>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <section id="portfolio">
            <div className="col-md-12">
                <h1 className="section-title" style={{ color: 'black' }}>
                    <span>{sectionName}</span>
                </h1>
                <div className="container mx-auto">{ProjectCardList}</div>
                <ProjectDetailsModal show={modalShow} onHide={detailsModalOnClose} data={projectData} />
            </div>
        </section>
    );
};

export default Projects;
